import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetOneEpisode({ podcastId, episodeId, enabled = false, configs = {} }) {
  const { privateFetch } = useContext(FetchContext);

  const getOneEpisode = async () => {
    const response = await privateFetch.get(
      `/v1/admin/podcast/${podcastId}/episode/${episodeId}`,
      configs
    );
    return response.data;
  };
  return useQuery(['get-one-episode', podcastId, episodeId], getOneEpisode, {
    enabled: Boolean(enabled && podcastId && episodeId),
    keepPreviousData: true,
  });
}

export default useGetOneEpisode;
